import { Apis, Constants } from "utils";

export interface IGithubData {
  all(): Promise<any>;
}

export class GithubData implements IGithubData {

  async all() {
    try {
      return await Apis.github().get(`users/${Constants.GITHUB.USERNAME}/repos`);
    } catch (err) {
      return null;
    }
  }
}
